/* Footer: insert credit, footnotes and data source.

Note: The logo can look awkward depending on the footnote text (especially if it wraps).
You may need to adjust the css to hide the spotlight logo for smaller screen widths or
simply remove it entirely.
*/

import React from "react";

const Footer = () => {
  const spotlight = "https://www.spotlightpa.org/";
  return (
    <div>
      <div className="footer__container">
        <div>
          <div className="footer__notes is-size-7">
            <i>
              'Full' means an agency collects race data for every stop.
              'Partial' means it collects it based on the outcome of the stop,
              eg. if a citation was issued.
            </i>
          </div>
          <div className="footer__byline-source is-size-7 has-text-grey">
            <span>Source: Spotlight PA survey, Sept 2019.</span>
            <span className="footer__source">
              <span className="footer__separator"></span>
              <span className="footer__byline">
                Chart: Daniel Simmons-Ritchie,{" "}
                <a href={spotlight}>Spotlight PA</a>
              </span>
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Footer;
